
import axios from 'axios'

// Quasarのポップアップを表示する

import {Notify} from 'quasar'

function notify(message) {
  const options = {
    type: 'negative',
    position: 'top',
    actions: [{icon: 'close'}],
  }
  if(message instanceof Object) {
    Object.assign(options, message)
  }
  else {
    options.message = message
  }
  Notify.create(options)
}

// error-reporterを経由しないconsole.error関数

const console_error = window.console.error

//

export default {
  install(Vue, options) { // eslint-disable-line no-unused-vars

    // 汎用ポップアップ
    Vue.prototype.$notify = notify

    // デフォルトバリデーションエラーハンドラ
    const onValidatonErrorDefault = function(errors) {
      notify(Object.values(errors).reduce((a, v) => [...a, ...v], []).join('\n'))
    }

    // アプリケーション例外ハンドラ
    Vue.prototype.$handler = function(e, onValidatonError = onValidatonErrorDefault) {

      // nullの場合はスルー
      if(e == null) {
        return
      }

      // Quasarのdialogなどのキャンセルの場合はスルー
      if(e.name === 'Error' && e.message === '') {
        return
      }

      // axiosのキャンセルの場合はスルー
      if(axios.isCancel(e)) {
        return
      }

      // axiosのエラーの場合
      if(e.name === 'Error' && e.request != null) {
        console_error(e)

        // 接続できない場合
        if(e.response == null) {
          notify('通信エラーが発生しました')
          return
        }

        // サーバーからのポップアップ表示要求
        if(e.response.status === 422 && e.response.data != null) {
          if(e.response.data.errors) {
            onValidatonError(e.response.data.errors)
            return
          }
          if(e.response.data.message) {
            notify(e.response.data.message)
            return
          }
        }

        // それ以外のサーバーエラーコード
        if(Vue.config.devtools) {
          notify('サーバーエラー status=' + e.response.status + ' content=' + JSON.stringify(e.response.data).substring(0, 1000))
          return
        }

        notify('サーバーエラー' + e.response.status + 'が発生しました')
        return
      }

      // それ以外のエラー
      console.error(e) // eslint-disable-line no-console
    }

  },
}
